import { render, staticRenderFns } from "./standardinfo.vue?vue&type=template&id=5a42160f&scoped=true"
import script from "./standardinfo.vue?vue&type=script&lang=js"
export * from "./standardinfo.vue?vue&type=script&lang=js"
import style0 from "./standardinfo.vue?vue&type=style&index=0&id=5a42160f&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a42160f",
  null
  
)

export default component.exports